<template>
  <ReportedListView />
</template>
<script>
// @ is an alias to /src
import ReportedListView from "@/components/ReportedListView";

export default {
  name: "ReportedUserListView",
  components: {
    ReportedListView,
  },
};
</script>